// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1240":"a6fd960a","3757":"c7e27268","5015":"a20cbfba","5860":"c6eeaa09","6342":"8577d229","7957":"efcef1b6","8407":"7a214ad0","8825":"91967795","9577":"0f4bd965"}[chunkId] + ".chunk.js";
};